<template>
  <form-modal
    :open="isAddModalOpen"
    :heading="$t('modals.expense.add')"
    entity="expense"
    mode="add"
    :submit-label="$t('modals.expense.save')"
    :fields="fields"
    :values="prefill"
    save-url="/add-expense.php"
    :build-payload="buildPayload"
    @update:open="$emit('update:isAddModalOpen', $event)"
    @opened="fetchSubcategories"
    @saved="$emit('expense-actions')"
  />
</template>

<script>
import { computed } from 'vue';
import { useSubcategoryOptions } from '@/composables/useSubcategoryOptions';
import FormModal from '@/components/common/FormModal.vue';
import { t } from '@/i18n';

export default {
    components: {
        FormModal,
    },
    props: {
        isAddModalOpen: {
            type: Boolean,
            required: true,
        },
        // Pre-fills the form (e.g. from a scanned receipt) instead of opening it blank. A new
        // object opens it filled in again; the default (blank) is what the plain "+" FAB uses.
        prefill: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['update:isAddModalOpen', 'expense-actions'],
    setup() {
        const { subcategoryGroups, fetchSubcategories } = useSubcategoryOptions();

        const fields = computed(() => [
            { key: 'subcat', label: t('fields.subcategory'), type: 'select', required: true, placeholder: t('placeholders.selectSubcategory'), groups: subcategoryGroups.value },
            { key: 'value', label: t('fields.value'), type: 'number', required: true },
            { key: 'note', label: t('fields.note'), type: 'text' },
            { key: 'date', label: t('fields.date'), type: 'date' },
        ]);

        const buildPayload = (form) => ({
            subcat: form.subcat,
            date: form.date,
            note: form.note,
            value: form.value,
        });

        return { fields, fetchSubcategories, buildPayload };
    },
};
</script>
